import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  deletePartnerPromotionApi,
  editPartnersPromotionsApi,
  getPartnerPromotionSettingsApi,
  getPartnersPromotionsDataApi,
  getVariantProductsApi,
  storePartnerPromotionApi,
  updatePartnerPromotionApi,
  viewPartnerPromotionApi,
  exportDifferenceDiscountReportApi,
} from "../../../services/partnerPromotion";

export const partnerProductSearch = [];

export const getPartnerPromotionList = createAsyncThunk("orders/getPartnerPromotionList", async (data, { dispatch }) => {
  const response = await getPartnersPromotionsDataApi(data);
  dispatch(setTableRowCount(response.response.count));
  return response.response.data;
});

export const storePartnerPromotion = createAsyncThunk("orders/storePartnerPromotion", async (promotionData, { dispatch, getState }) => {
  try {
    const response = await storePartnerPromotionApi(promotionData);
    const data = response.response;
    toast.success("New promotion added successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });

    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});
export const updatePartnerPromotion = createAsyncThunk("orders/updatePartnerPromotion", async (promotionData, { dispatch, getState }) => {
  try {
    const response = await updatePartnerPromotionApi(promotionData);
    const data = response.response;
    toast.success("Promotion updated successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });

    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const editPartnerPromotion = createAsyncThunk("orders/editPartnerPromotion", async (data, { dispatch }) => {
  const response = await editPartnersPromotionsApi(data.id, data.params);
  return response.response;
});
export const getVariantProductList = createAsyncThunk("orders/getVariantProductList", async (data, { dispatch }) => {
  const response = await getVariantProductsApi(data);
  return response.response;
});
export const viewPartnerPromotion = createAsyncThunk("orders/viewPartnerPromotion", async (data, { dispatch }) => {
  const response = await viewPartnerPromotionApi(data.id, data.params);
  return response.response;
});
export const getPartnerPromotionSettings = createAsyncThunk("orders/getPartnerPromotionSettings", async (data, { dispatch }) => {
  const response = await getPartnerPromotionSettingsApi(data);
  return response.response;
});

export const deletePartnerPromotion = createAsyncThunk('orders/deletePartnerPromotion',async (id, {dispatch})=>{
  const response = await deletePartnerPromotionApi(id);
  dispatch(getPartnerPromotionList());
  toast.success("Delete partner promotion successfully", {
      position: toast.POSITION.TOP_RIGHT,
  });
  return response.response;
});

export const exportDifferenceDiscountReport = createAsyncThunk('report/exportDifferenceDiscountReport', async (data, { dispatch }) => {
    const response = await exportDifferenceDiscountReportApi(data);
    return response.response;
});

const partnerPromotionAdapter = createEntityAdapter({});

export const { selectAll: selectPartnerPromotionsDiscounts, selectById: partnerPromotionsDiscountsById } = partnerPromotionAdapter.getSelectors(
  (state) => state.partnerPromotion.partnerPromotion
);

const partnersPromotionSlice = createSlice({
  name: "partnerPromotion",
  initialState: partnerPromotionAdapter.getInitialState({
    searchText: "",
    searchProduct: "",
    tableRow: 0,
    showTableRow: 0,
    productListDialogs: {
      type: 1,
      title: "",
      props: {
        isOpen: false,
      },
    },
    partnerPromotionSetting: {
      partners: [],
      users: [],
      tags: [],
      collections: [],
    },
    products: {
      data: [],
      pagination: {
        count: 0,
        next_page: 1,
        total: 0,
        has_more: false,
      },
    },
    promotions_products: {
      data: [],
      pagination: {
        count: 0,
        next_page: 1,
        total: 0,
        has_more: false,
      },
    },
    searchProductDialogProps: {
      props: {
        isOpen: false,
      },
      data: { searchValue: "" },
    },
    viewFormFilteres: {
      name: "",
      page: 1,
      pageSize: 10,
    },
  }),
  reducers: {
    setTableRowCount: (state, action) => {
      state.tableRow = action.payload;
    },
    setViewFormFilteres: (state, action) => {
      state.viewFormFilteres = {
        ...state.viewFormFilteres,
        ...action.payload,
      };
    },
    setShowTableRowCount: (state, action) => {
      state.showTableRow = action.payload;
    },
    setPartnerPromotionSettings: (state, action) => {
      state.partnerPromotionSetting = action.payload;
    },
    openProductListDialogs: (state, action) => {
      state.productListDialogs = action.payload;
    },
    setSearchProductDialog: (state, action) => {
      state.searchProductDialogProps = action.payload;
    },
    setProducts: (state, action) => {
      state.products.data = action.payload.data;
      state.products.pagination = action.payload.pagination;
    },
    setPromotionsProducts: (state, action) => {
      state.promotions_products.data = action.payload.data;
      state.promotions_products.pagination = action.payload.pagination;
    },
    setProductSearch: (state, action) => {
      state.searchProduct = action.payload;
    },
    closeProductListDialog: (state, action) => {
      state.productListDialogs = {
        type: 1,
        title: "",
        props: {
          isOpen: false,
        },
      };
    },
  },
  extraReducers: {
    [getPartnerPromotionList.fulfilled]: partnerPromotionAdapter.setAll,
    // [updateStaff.fulfilled]: staffsAdapter.setAll
    // [deleteStaff.fulfilled]: staffsAdapter.removeOne,
  },
});

export const {
  setTableRowCount,
  setShowTableRowCount,
  openProductListDialogs,
  closeProductListDialog,
  setSearchProductDialog,
  setProducts,
  setViewFormFilteres,
  setPartnerPromotionSettings,
  setPromotionsProducts,
  setProductSearch,
} = partnersPromotionSlice.actions;

export default partnersPromotionSlice.reducer;
